import { render, staticRenderFns } from "./other_information.vue?vue&type=template&id=4d075386&"
import script from "./other_information.vue?vue&type=script&lang=js&"
export * from "./other_information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports